import React, { FC } from "react";
import { Row, Col } from "antd";
import ProductActionHeader from "../../components/productActionHeader";
import ProductActionImage from "../../components/productActionImage";
import ProductActionInfo from "../../components/productActionInfo";
import ProductActionForm from "../../components/productActionForm";
import { useParams } from "react-router-dom";
import AdditionBatch from "../../components/additionBatch";
import "./actionProduct.style.scss";

const ActionProduct: FC = () => {
  const { skuId } = useParams();
  return (
    <Row gutter={[0, 24]} justify="center">
      <Col span={23}>
        <ProductActionHeader />
      </Col>
      {skuId === "group" ? (
        <Col span={23}>
          <AdditionBatch />
        </Col>
      ) : (
        <Col span={16}>
          <Row gutter={[10, 10]} className="box">
            <Col span={9}>
              <ProductActionImage />
            </Col>
            <Col span={15}>
              <ProductActionInfo />
              <ProductActionForm />
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};
export default ActionProduct;
